import {ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {HeaderService} from '../../../services/header-service';
import {NotificationStyleService} from '../../../services/notification-style-service';
import {LoginService} from '../../../services/login.service';
import {JsonPipe, NgForOf, NgIf} from '@angular/common';
import {IconComponent} from '../../elements/icon/icon.component';
import {Icons, IconsClouds, IconsCloudsArray} from '../../../model/icon';
import {ContinentService} from "../../../services/continent-service";
import {
  AdditionalFields,
  Events,
  LocationDto,
  Points,
  VoucherDisplay,
  VoucherDto,
  VoucherTemplate
} from "../../../model/continent";
import {environment} from "../../../environments/environment";
import {Carousel} from '../../../model/carousel';
import {NotificationService} from '../../../services/notification-service';
import {Notification, NotificationType} from '../../../model/notification';
import {sortOrder} from '../../../functions/sortOrder';
import {CountryService} from '../../../services/country-service';
import {CityService} from '../../../services/city-service';
import {HotelDtoService} from '../../../services/hotel-dto-service';
import {HotelPageComponent} from '../hotel-page/hotel-page.component';
import {Pagination, PaginationParams} from '../../../model/pagination';
import {PaginationComponent} from '../../elements/pagination/pagination.component';
import {Router, RouterLink} from '@angular/router';
import {SortableTableComponent} from '../../elements/sortable-table/sortable-table.component';
import {Header} from '../../../model/header';
import {AdminSettings} from '../../../model/adminSettings';
import {AdminStorageService} from '../../../services/admin.storage.service';
import {lastValueFrom} from 'rxjs';
import {AdventuresService} from '../../../services/adventures-service';
import {LoadingComponent} from '../../elements/loading/loading.component';
import {MultiSelectDropdownComponent} from '../../elements/multi-select-dropdown/multi-select-dropdown.component';
import {ColorPickerComponent} from './elements/color-picker/color-picker.component';
import {RouteService} from '../../../services/route-service';
import {ButtonComponent} from '../../elements/button/button.component';
import {findIconByAlt} from '../../../functions/findIconByAlt';
import {findFirstContinent, findFirstCountryUrl} from '../../../functions/findFirstCityUrl';
import {TokenStorageService} from '../../../services/token.storage.service';
import {DomSanitizer} from '@angular/platform-browser';
import {PdfViewerComponent} from './elements/pdf-viewer/pdf-viewer.component';
import {VoucherService} from '../../../services/voucher-service';

@Component({
  selector: 'app-admin',
  imports: [
    NgForOf,
    IconComponent,
    NgIf,
    ReactiveFormsModule,
    HotelPageComponent,
    PaginationComponent,
    FormsModule,
    SortableTableComponent,
    LoadingComponent,
    ColorPickerComponent,
    JsonPipe,
    PdfViewerComponent,
    RouterLink
  ],
  templateUrl: './admin.component.html',
  standalone: true,
  styleUrl: './admin.component.scss'
})


export class AdminComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput', { static: false }) private fileInput!: ElementRef;
  @ViewChild('descriptionEn', { static: false }) descriptionEn!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('descriptionRu', { static: false }) descriptionRu!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('continentSelect') continentSelect!: ElementRef<HTMLSelectElement>;
  @ViewChild('countrySelect') countrySelect!: ElementRef<HTMLSelectElement>;
  @ViewChild('citySelect') citySelect!: ElementRef<HTMLSelectElement>;


  constructor(protected interfaceService: HeaderService,
              protected notificationStyle: NotificationStyleService,
              protected loginService: LoginService,
              protected continentService: ContinentService,
              protected countryService: CountryService,
              protected cityService: CityService,
              protected hotelService: HotelDtoService,
              protected adventuresService: AdventuresService,
              protected routeService: RouteService,
              protected voucherService: VoucherService,
              protected notificationService: NotificationService,
              protected adminSettings: AdminStorageService,
              private fb: FormBuilder,
              private changeDetectorRef: ChangeDetectorRef,
              private router: Router,
              private tokenStorageService: TokenStorageService,
              private sanitizer: DomSanitizer) {
              this.myForm = this.fb.group({});
  }


  headers: ('continents' | 'countries' | 'cities' | 'hotels' | 'adventures' | 'routes' | 'vouchers')[] = [
    'continents', 'countries', 'cities', 'hotels', 'adventures', 'routes'
  ]
  activeSection: 'continents' | 'countries' | 'cities' | 'hotels' | 'adventures' | 'routes' | 'vouchers' = this.headers[0];
  items: any[] = [];
  editMode: 'list' | 'item' = 'list';
  fileChangeType: 'main' | 'continent' | 'additional' | 'event' | 'additionalEvent' | 'footer' | 'point' | 'pointEvent' | 'icon' | 'iconActive' = 'main';
  myForm: FormGroup;
  imageUrl: string | null = null;
  errorMessage: string | null = null;
  location: LocationDto = new LocationDto();
  voucher: VoucherDto = new VoucherDto();
  carouselActiveIdx: number | null = null;
  options: any[] = [];
  displayPreview: boolean = true;
  search: string = '';
  voucherActiveIdx: number = 0;

  loading: boolean = false;

  loadingForSaving: boolean = false;

  currentSortHeader: string = '';
  currentSort: string = '';

  continentList: any[] = [];
  countryList: any[] = [];
  cityList: any[] = [];
  PointsCityList: LocationDto[] = [];
  hotelAdventuresList: LocationDto[] = [];
  adventuresList: any[] = [];
  routesList: any[] = [];
  voucherTemplateFields: any[] = [];
  voucherCustomFields: AdditionalFields[] = [];

  eventActiveIdx: number | null = null;
  eventActivePointIdx: number | null = null;
  eventActivePointJIdx: number | null = null;
  ActivePointJIdx: number | null = null;
  eventAdditionalActiveIdx: number | null = null;

  activePointTab: number | null = null;

  arrKeys = ['carousel', 'events', 'imageAdditional', 'additionalEvents', 'points', 'adventures'];
  imgsKeys = ['iconImg', 'iconActiveImg'];

  pos: string[] = [];
  eventPos: string[] = [];
  additionalEventPos: string[] = [];
  innerPos: string[][] = [];
  mainPos: string = '';
  footerPos: string = '';
  additionalPos: string = '';
  voucherTypeNg: string = '';

  position: string[] = [
    'top',
    'center',
    'bottom'
  ];

  voucherTypes: VoucherTemplate[] = [];

  role: 'admin' | 'VOUCHER_MANAGER' = 'VOUCHER_MANAGER';

  pdfUrl: string = 'app/assets/test.pdf';

  iconPos1: string[] = [];
  iconPos2: string[] = [];
  iconPos3: string[] = [];
  textPosEn1: string[] = [];
  textPosEn2: string[] = [];
  textPosEn3: string[] = [];
  textPosRu1: string[] = [];
  textPosRu2: string[] = [];
  textPosRu3: string[] = [];
  linkPos: string[] = [];

  selectedCityForPoint: { [key: number]: string } = {};

  getClearSorting: number = 0;

  continentFilterId: number | null = null;
  countryFilterId: number | null = null;

  settings: AdminSettings = new AdminSettings();

  header: Header[] = [];
  headerDefault: Header[] = [
    {
      title: 'title',
      key: 'titleEn',
      img: true,
      sortable: true,
    },
    {
      title: '',
      key: '',
      edit: true,
      width: "100px",
      sortable: false,
    },
  ];
  pagination: Pagination<any> = {page: {number: 0, totalPages: 0, size: 0, totalElements: 0}, content: []};


  defaultParams = new PaginationParams({
    sort: '',
    query: '',
    pageSize: 5,
    pageNumber: 0,
  });

  params: PaginationParams = new PaginationParams(this.defaultParams);

  paramsList: PaginationParams = new PaginationParams({
    query: '',
    pageSize: 1000,
    pageNumber: 0,
    sort: 'titleEn:ASC',
  });

  paramsListPointsCities: PaginationParams = new PaginationParams({
    query: '',
    pageSize: 1000,
    pageNumber: 0,
    sort: 'titleEn:ASC',
  });

  paramsListHotelsAdventures: PaginationParams = new PaginationParams({
    query: '',
    pageSize: 100,
    pageNumber: 0,
    sort: 'titleEn:ASC',
  });

  footerColor: string = 'rgba(57, 122, 158, 1)';

  private tokenCheckInterval?: any;

  ngOnInit() {
    this.initializeComponent();
    this.startTokenMonitoring();
  }

  ngOnDestroy(): void {
    if (this.tokenCheckInterval) {
      clearInterval(this.tokenCheckInterval);
    }
  }

  private initializeComponent(): void {
    // if (!this.tokenStorageService.canAccessAdmin()) {
    //   this.router.navigate(['/login']);
    //   return;
    // }
    if (this.tokenStorageService.hasRole('admin')) {
      this.role = 'admin';
      this.headers = [
        'continents',
        'countries',
        'cities',
        'hotels',
        'adventures',
        'routes',
      ]
    }
    this.interfaceService.setPageInterface('header-container-white');
    this.notificationStyle.setActiveStyle(1);
    this.settings = this.adminSettings.getAdminSetting();
    if (this.settings) {
      this.params = this.settings.paginationParams;
      this.currentSortHeader = this.settings.currentSortHeader;
      this.currentSort = this.settings.currentSort;
      this.activeSection = this.settings.activeSection;
      this.search = this.settings.search;
      setTimeout(() => {
        if (this.params.continentId) {
          const selectElement = this.continentSelect.nativeElement;
          selectElement.value = this.params.continentId;
        }
        if (this.params.countryId) {
          const selectElement = this.countrySelect.nativeElement;
          selectElement.value = this.params.countryId;
        }
        if (this.params.cityId) {
          const selectElement = this.citySelect.nativeElement;
          selectElement.value = this.params.cityId;
        }
      }, 800);
    } else {
      this.settings = new AdminSettings();
    }
    this.getList();
    this.getFields();
    this.getSelectLists();
  }

  private startTokenMonitoring(): void { // Добавить метод мониторинга токена
    this.tokenCheckInterval = setInterval(() => {
      if (!this.tokenStorageService.isTokenValid()) {
        this.tokenStorageService.logout();
      }
    }, 30000); // Проверка каждые 30 секунд
  }

  changeActive(tab: 'continents' | 'countries' | 'cities' | 'hotels' | 'adventures' | 'routes'| 'vouchers') {
    this.activeSection = tab;
    this.params = this.defaultParams;
    this.settings.activeSection = this.activeSection;
    this.settings.paginationParams = this.params;
    this.adminSettings.setAdminSetting(this.settings);
    this.clearSearch();
    this.getList();
    this.getFields();
  }

  getList() {
    this.loading = true;
    switch (this.activeSection) {
      case 'continents': {
        this.continentService.getContinentList(this.params).subscribe((data) => {
          this.loading = false;
          this.pagination = data;
          this.header = this.headerDefault;
        });
        break;
      }
      case 'countries' : {
        if (this.continentFilterId != null) {
          this.countryService.getCountryListByContinent(this.params, this.continentFilterId).subscribe((data) => {
            this.loading = false;
            this.pagination = data;
            this.header = this.headerDefault;
          });
        } else {
          this.countryService.getCountryList(this.params).subscribe((data) => {
            this.loading = false;
            this.pagination = data;
            this.header = this.headerDefault;
          });
        }
        break;
      }
      case 'cities' : {
        if (this.countryFilterId != null) {
          this.cityService.getCityListByCountry(this.params, this.countryFilterId).subscribe((data) => {
            this.loading = false;
            this.pagination = data;
            this.header = this.headerDefault;
          });
        } else {
          this.cityService.getCityList(this.params).subscribe((data) => {
            this.loading = false;
            this.pagination = data;
            this.header = this.headerDefault;
          });
        }
        break;
      }
      case 'hotels' : {
        this.hotelService.getHotelList(this.params).subscribe((data) => {
          this.loading = false;
          this.pagination = data;
          this.header = [
            {
              title: 'title',
              key: 'titleEn',
              img: true,
            },
            {
              title: 'continent',
              key: 'city.country.continent.titleEn',
            },
            {
              title: 'country',
              key: 'city.country.titleEn',
            },
            {
              title: 'city',
              key: 'city.titleEn',
            },
            {
              title: '',
              key: '',
              edit: true,
              width: "100px",
            },
          ];
        });
        break;
      }
      case 'adventures' : {
        this.adventuresService.getAdventureList(this.params).subscribe((data) => {
          this.loading = false;
          this.pagination = data;
          this.header = this.headerDefault;
        });
        break;
      }
      case 'routes' : {
        this.routeService.getRouteList(this.params).subscribe((data) => {
          this.loading = false;
          this.pagination = data;
          this.header = this.headerDefault;
        });
        break;
      }
      case 'vouchers' : {
        this.voucherService.getVouchersList(this.params).subscribe((data) => {
          this.loading = false;
          const displayData = {
            ...data,
            content: data.content ? data.content.map((voucher: VoucherDto) => {
              const displayVoucher: VoucherDisplay = {
                ...voucher,
                content1: '',
                content2: '',
                content3: '',
                content4: ''
              };

              if (voucher.additionalFields && voucher.additionalFields.length > 0) {
                displayVoucher.content1 = voucher.additionalFields[0]?.value || '';
                displayVoucher.content2 = voucher.additionalFields[1]?.value || '';
                displayVoucher.content3 = voucher.additionalFields[2]?.value || '';
                displayVoucher.content4 = voucher.additionalFields[3]?.value || '';
              }

              return displayVoucher;
            }) : []
          };
          this.pagination = displayData;
          if (window.innerWidth > 576) {
            this.header = this.header = [
              {
                title: 'Type',
                key: 'type',
              },
              {
                title: 'content(1)',
                key: 'content1',
                sortable: false
              },
              {
                title: 'content(2)',
                key: 'content2',
                sortable: false
              },
              {
                title: 'content(3)',
                key: 'content3',
                sortable: false
              },
              {
                title: 'content(4)',
                key: 'content4',
                sortable: false
              },
              {
                title: '',
                key: '',
                edit: true,
                width: "100px",
              },
            ];
          } else {
            this.header = this.header = [
              {
                title: 'Type',
                key: 'type',
              },
              {
                title: 'name',
                key: 'clientName',
              },
              {
                title: 'hotel',
                key: 'hotelAddress',
              },
              {
                title: 'Start',
                key: 'startDate',
                addKey: 'checkInTime',
                date: true
              },
              {
                title: 'End',
                key: 'endDate',
                addKey: 'checkOutTime',
                date: true
              },
            ];
          }
        });
        break;
      }
    }
  }

  setPagination(pagination: Pagination<any>) {
    this.pagination = pagination;
    if (this.params.pageSize != this.pagination.page.size) {
      this.params.pageSize = this.pagination.page.size;
      this.params.pageNumber = 0;
    } else {
      this.params.pageNumber = this.pagination.page.number;
    }
    this.settings.paginationParams = this.params;
    this.adminSettings.setAdminSetting(this.settings);
    this.getList();
  }

  getSelectLists() {
    if (this.role == 'admin') {
      this.continentService.getContinentList(this.paramsList).subscribe((data) => {
        this.continentList = data.content ?? [];
      });
      this.countryService.getCountryList(this.paramsList).subscribe((data) => {
        this.countryList = data.content ?? [];
      });
      this.cityService.getCityList(this.paramsList).subscribe((data) => {
        this.cityList = data.content ?? [];
      });
      this.adventuresService.getAdventureList(this.paramsList).subscribe((data) => {
        this.adventuresList = data.content ?? [];
      });
      this.routeService.getRouteList(this.paramsList).subscribe((data) => {
        this.routesList = data.content ?? [];
      });
    }
  }

  onColorSelected(color: string) {
    this.footerColor = color;
    this.location.footerColor = color;
  }

  getFields() {
    this.myForm.reset();
    Object.keys(this.myForm.controls).forEach(control => {
      this.myForm.removeControl(control);
    });
    switch (this.activeSection) {
      case 'continents': {
        this.myForm.addControl('id', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('version', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('url', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleEn', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleRu', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('mainPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('footerPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('descriptionEn', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('descriptionRu', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('runningLine', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('runningLineRu', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('displayPage', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('carousel', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('events', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('additionalEvents', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('footerColor', this.fb.control({value: '', disabled: false}));
        break;
      }
      case 'countries' : {
        this.myForm.addControl('id', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('version', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('url', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleEn', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleRu', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('mainPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('footerPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('titleAccusativeRu', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('titleNatural', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('descriptionEn', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('descriptionRu', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('displayPage', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('continentId', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('carousel', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('imageAdditional', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('events', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('iconImg', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('continentFilter', this.fb.control({value: '', disabled: false}));
        // this.myForm.addControl('iconActiveImg', this.fb.control({ value: '', disabled: false }));
        this.options = this.continentList;
        break;
      }
      case 'cities' : {
        this.myForm.addControl('id', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('version', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('url', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleEn', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleRu', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('mainPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('footerPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('descriptionEn', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('descriptionRu', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('displayPage', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('countryId', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('carousel', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('events', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('additionalEvents', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('countryFilter', this.fb.control({value: '', disabled: false}));
        this.countryService.getCountryList(this.paramsList).subscribe((data) => {
          this.options = this.countryList;
        });
        break;
      }
      case 'hotels' : {
        this.myForm.addControl('id', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('version', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('url', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleEn', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleRu', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('mainPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('footerPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('descriptionEn', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('descriptionRu', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('cityId', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('address', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('link', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('rating', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('displayPage', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('withoutCity', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('withoutCountry', this.fb.control({value: '', disabled: false}));
        // this.myForm.addControl('backgroundStyle', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('adventures', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('preview', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('continentFilter', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('countryFilter', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('cityFilter', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('hotelsAdventures', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('miniDescriptionEn', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('miniDescriptionRu', this.fb.control({value: '', disabled: false}));
        setTimeout(() => {
          this.options = this.cityList;
        }, 500);
        break;
      }
      case 'adventures' : {
        this.myForm.addControl('id', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('version', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('url', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleEn', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleRu', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('mainPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('footerPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('image', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('descriptionEn', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('descriptionRu', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('events', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('footerColor', this.fb.control({value: '', disabled: false}));
        break;
      }
      case 'routes' : {
        this.myForm.addControl('id', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('version', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('url', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleEn', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('titleRu', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('mainPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('footerPicture', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('image', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('map', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('runningLineEn', this.fb.control({value: '', disabled: false}, Validators.required));
        this.myForm.addControl('runningLineRu', this.fb.control({value: '', disabled: false}, Validators.required));
        // this.myForm.addControl('carousel', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('points', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('displayPage', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('footerColor', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('continentFilter', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('countryFilter', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('cityFilter', this.fb.control({value: '', disabled: false}));
        this.options = this.routesList;
        break;
      }
      case 'vouchers': {
        this.myForm.addControl('voucherType', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('version', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('id', this.fb.control({value: '', disabled: true}));
        this.myForm.addControl('clientName', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('hotelName', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('startDate', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('endDate', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('checkInTime', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('checkOutTime', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('hotelConfirmationNumber', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('accommodation', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('mealPlan', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('hotelAddress', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('emergency', this.fb.control({value: '', disabled: false}));
        this.myForm.addControl('type', this.fb.control({value: '', disabled: false}));
      }
    }
  }

  saveEntity(requestData: LocationDto) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.saveContinent(requestData);
      }
      case 'countries': {
        return this.countryService.saveCountry(requestData);
      }
      case 'cities': {
        return this.cityService.saveCity(requestData);
      }
      case 'hotels': {
        return this.hotelService.saveHotel(requestData);
      }
      case 'adventures': {
        return this.adventuresService.saveAdventure(requestData);
      }
      case 'routes': {
        return this.routeService.saveRoute(requestData);
      }
      case 'vouchers': {
        return this.routeService.saveRoute(requestData);
      }
    }
  }

  saveMainPhoto(id: number, file: File) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.saveContinentPhoto(id, file);
      }
      case 'countries': {
        return this.countryService.saveCountryPhoto(id, file);
      }
      case 'cities': {
        return this.cityService.saveCityPhoto(id, file);
      }
      case 'hotels': {
        return this.hotelService.saveHotelPhoto(id, file);
      }
      case 'adventures': {
        return this.adventuresService.saveAdventurePhoto(id, file);
      }
      case 'routes': {
        return this.routeService.saveRouteFile(id, file);
      }
      case 'vouchers': {
        return this.routeService.saveRouteFile(id, file);
      }
    }
  }

  saveFooterPhoto(id: number, file: File) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.saveContinentFooterPhoto(id, file);
      }
      case 'countries': {
        return this.countryService.saveCountryFooterPhoto(id, file);
      }
      case 'cities': {
        return this.cityService.saveCityFooterPhoto(id, file);
      }
      case 'hotels': {
        return this.hotelService.saveHotelPhoto(id, file);
      }
      case 'adventures': {
        return this.adventuresService.saveAdventureFooterPhoto(id, file);
      }
      case 'routes': {
        return this.routeService.saveRouteFooterPhoto(id, file);
      }
      case 'vouchers': {
        return this.routeService.saveRouteFooterPhoto(id, file);
      }
    }
  }

  saveCountryIcon(id: number, file: File) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.saveContinentFooterPhoto(id, file);
      }
      case 'countries': {
        return this.countryService.saveCountryIcon(id, file);
      }
      case 'cities': {
        return this.cityService.saveCityFooterPhoto(id, file);
      }
      case 'hotels': {
        return this.hotelService.saveHotelPhoto(id, file);
      }
      case 'adventures': {
        return this.adventuresService.saveAdventureFooterPhoto(id, file);
      }
      case 'routes': {
        return this.routeService.saveRouteFooterPhoto(id, file);
      }
      case 'vouchers': {
        return this.routeService.saveRouteFooterPhoto(id, file);
      }
    }
  }

  saveCountryIconActive(id: number, file: File) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.saveContinentFooterPhoto(id, file);
      }
      case 'countries': {
        return this.countryService.saveCountryIconActive(id, file);
      }
      case 'cities': {
        return this.cityService.saveCityFooterPhoto(id, file);
      }
      case 'hotels': {
        return this.hotelService.saveHotelPhoto(id, file);
      }
      case 'adventures': {
        return this.adventuresService.saveAdventureFooterPhoto(id, file);
      }
      case 'routes': {
        return this.routeService.saveRouteFooterPhoto(id, file);
      }
      case 'vouchers': {
        return this.routeService.saveRouteFooterPhoto(id, file);
      }
    }
  }

  saveAdditionalPhoto(id: number, file: File) {
    return this.countryService.saveCountryAdditionalPhoto(id, file);
  }

  saveCarouselPhoto(entityId: number, id: number, file: File) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.saveContinentCarousel(entityId, id, file)
      }
      case 'countries': {
        return this.countryService.saveCountryCarousel(entityId, id, file)
      }
      case 'cities': {
        return this.cityService.saveCityCarousel(entityId, id, file)
      }
      case 'hotels': {
        return this.hotelService.saveHotelCarousel(entityId, id, file)
      }
      case 'adventures': {
        return this.adventuresService.saveAdventureCarousel(entityId, id, file);
      }
      case 'routes': {
        return this.routeService.saveRouteCarousel(entityId, id, file);
      }
      case 'vouchers': {
        return this.routeService.saveRouteCarousel(entityId, id, file);
      }
    }
  }

  saveEventsPhoto(entityId: number, id: number, file: File) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.saveEventPhoto(entityId, id, file)
      }
      case 'countries': {
        return this.countryService.saveEventPhoto(entityId, id, file)
      }
      case 'cities': {
        return this.cityService.saveEventPhoto(entityId, id, file)
      }
      case 'hotels': {
        return this.hotelService.saveHotelCarousel(entityId, id, file)
      }
      case 'adventures': {
        return this.adventuresService.saveEventPhoto(entityId, id, file);
      }
      case 'routes': {
        return this.routeService.saveRouteCarousel(entityId, id, file);
      }
      case 'vouchers': {
        return this.routeService.saveRouteCarousel(entityId, id, file);
      }
    }
  }

  async savePointEventsPhoto(routeId: number, pointId: number, eventId: number, file: File) {
    if (!routeId || !pointId || !eventId) {
      throw new Error('Missing required IDs');
    }
    try {
      const response = await lastValueFrom(
        this.routeService.savePointEventPhoto(routeId, pointId, eventId, file)
      );
      const point = this.location.points.find(p => p.id === pointId);
      if (point) {
        const event = point.events.find(e => e.id === eventId);
        if (event) {
          event.image = response.image;
          event.file = undefined;
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  saveAdditionalEventsPhoto(entityId: number, id: number, file: File) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.saveAdditionalEventPhoto(entityId, id, file)
      }
      case 'countries': {
        return this.countryService.saveEventPhoto(entityId, id, file)
      }
      case 'cities': {
        return this.cityService.saveAdditionalEventPhoto(entityId, id, file)
      }
      case 'hotels': {
        return this.hotelService.saveHotelCarousel(entityId, id, file)
      }
      case 'adventures': {
        return this.adventuresService.saveEventPhoto(entityId, id, file);
      }
      case 'routes': {
        return this.routeService.saveRouteCarousel(entityId, id, file);
      }
      case 'vouchers': {
        return this.routeService.saveRouteCarousel(entityId, id, file);
      }
    }
  }

  deleteCarouselEntity(entityId: number, id: number) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.deleteContinentCarousel(entityId, id)
      }
      case 'countries': {
        return this.countryService.deleteCountryCarousel(entityId, id)
      }
      case 'cities': {
        return this.cityService.deleteCityCarousel(entityId, id)
      }
      case 'hotels': {
        return this.hotelService.deleteContinentCarousel(entityId, id)
      }
      case 'adventures': {
        return this.adventuresService.deleteAdventureCarousel(entityId, id);
      }
      case 'routes': {
        return this.routeService.deleteRouteCarousel(entityId, id);
      }
      case 'vouchers': {
        return this.routeService.deleteRouteCarousel(entityId, id);
      }
    }
  }

  deleteEventEntity(entityId: number, id: number) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.deleteEventCarousel(entityId, id)
      }
      case 'countries': {
        return this.countryService.deleteEventCountry(entityId, id)
      }
      case 'cities': {
        return this.cityService.deleteEventCity(entityId, id)
      }
      case 'hotels': {
        return this.hotelService.deleteContinentCarousel(entityId, id)
      }
      case 'adventures': {
        return this.adventuresService.deleteEventAdventure(entityId, id);
      }
      case 'routes': {
        return this.routeService.deleteRouteCarousel(entityId, id);
      }
      case 'vouchers': {
        return this.routeService.deleteRouteCarousel(entityId, id);
      }
    }
  }

  deleteAdditionalEventEntity(entityId: number, id: number) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.deleteContinentCarousel(entityId, id)
      }
      case 'countries': {
        return this.countryService.deleteCountryCarousel(entityId, id)
      }
      case 'cities': {
        return this.cityService.deleteAdditionalEvent(entityId, id)
      }
      case 'hotels': {
        return this.hotelService.deleteContinentCarousel(entityId, id)
      }
      case 'adventures': {
        return this.adventuresService.deleteAdventureCarousel(entityId, id);
      }
      case 'routes': {
        return this.routeService.deleteRouteCarousel(entityId, id);
      }
      case 'vouchers': {
        return this.routeService.deleteRouteCarousel(entityId, id);
      }
    }
  }

  deletePointEventEntity(routeId: number, pointId: number, eventId: number) {
    return this.routeService.deletePointEvent1(routeId, pointId, eventId);
  }

  deletePoint(idRoute: number, pointId: number) {
    return this.routeService.deletePoint(idRoute, pointId);
  }

  // onClickPointImage(i: number) {
  //   this.eventActivePointIdx = i;
  //   this.fileChangeType = 'point';
  //   this.fileInput.nativeElement.click();
  // }

  addPointImage(file: File) {
    if (this.eventActivePointIdx !== null) {
      const point = this.location.points[this.eventActivePointIdx];
      if (point) {
        point.image = this.imageUrl ?? '';
        point.file = file;
      }
    }
    this.resetFileSelection();
  }

  deleteElementPoint(pointIndex: number) {
    if (!this.location.points || !this.location.points[pointIndex]) {
      return;
    }
    const point = this.location.points[pointIndex];
    if (point.id !== undefined && point.id !== null) {
      point.toDelete = true;
    } else {
      this.location.points.splice(pointIndex, 1);
    }
    this.myForm.get('points')?.setValue([...this.location.points]);
    this.changeDetectorRef.detectChanges();
  }

  getTitle() {
    switch (this.activeSection) {
      case 'continents': {
        return 'continent';
      }
      case 'countries': {
        return 'country';
      }
      case 'cities': {
        return 'city';
      }
      case 'hotels': {
        return 'hotel';
      }
      case 'adventures': {
        return 'adventure';
      }
      case 'routes': {
        return 'route';
      }
      case 'vouchers': {
        return 'vouchers';
      }
    }
  }

  setParamsSearch(id: string, section: 'continent' | 'country' | 'cities') {
    switch (this.activeSection) {
      case 'continents': {
        break;
      }
      case 'countries': {
        switch (section) {
          case "continent": {
            this.continentFilterId = Number(id);
            break;
          }
          case "country": {
            break;
          }
          case "cities": {
            break;
          }
        }
        break;
      }
      case 'cities': {
        switch (section) {
          case "continent": {
            break;
          }
          case "country": {
            this.countryFilterId = Number(id);
            break;
          }
          case "cities": {
            break;
          }
        }
        break;
      }
      case 'hotels': {
        switch (section) {
          case "continent": {
            this.params.continentId = id;
            break;
          }
          case "country": {
            this.params.countryId = id;
            break;
          }
          case "cities": {
            this.params.cityId = id;
            break;
          }
        }
        break;
      }
      case 'adventures': {
        break;
      }
      case 'routes': {
        switch (section) {
          case "continent": {
            this.params.continentId = id;
            break;
          }
          case "country": {
            this.params.countryId = id;
            break;
          }
          case "cities": {
            this.params.cityId = id;
            break;
          }
        }
        break;
      }
    }
    this.settings.paginationParams = this.params;
  }

  clearFilters() {
    const continentSelect = document.getElementById('continentSelect') as HTMLSelectElement;
    const countrySelect = document.getElementById('countrySelect') as HTMLSelectElement;
    const citySelect = document.getElementById('citySelect') as HTMLSelectElement;
    if (continentSelect) {
      continentSelect.value = '';
    }
    if (countrySelect) {
      countrySelect.value = '';
    }
    if (citySelect) {
      citySelect.value = '';
    }
  }


  getCleanFormData() {
    const rawData = this.myForm.value;
    const cleanedData = Object.keys(rawData).reduce((acc: any, key) => {
      if (rawData[key] === null) {
        if (this.arrKeys.includes(key)) {
          acc[key] = [];
        } else {
          acc[key] = '';
        }
      } else {
        acc[key] = rawData[key];
      }
      if (this.imgsKeys.includes(key)) {
        delete acc[key];
      }
      if (key === 'carousels' && Array.isArray(this.location.carousels)) {
        acc[key] = this.location.carousels.map((carousel, index) => ({
          ...carousel,
          orderNumber: carousel.orderNumber ?? index
        }));
      }
      return acc;
    }, {});

    if (!cleanedData.points && this.location.points) {
      cleanedData.points = this.location.points;
    }
    if (this.activeSection === 'routes') {
      cleanedData.points = this.location.points || [];
      cleanedData.points = cleanedData.points.map((point: Points, index: number) => ({
        ...point,
        orderNumber: point.orderNumber ?? index,
        cities: point.cities || [],
        events: point.events || [],
      }));
    }
    if (this.location.footerColor) {
      cleanedData.footerColor = this.location.footerColor;
    }
    if (!cleanedData.points && this.location.points) {
      cleanedData.points = this.location.points.map(point => ({
        ...point,
        cities: point.cities?.map(city => ({id: city.id})) || [],
        orderNumber: point.orderNumber
      }));
    }

    return cleanedData;
  }


  onSubmit() {
    if (this.myForm.valid) {
      this.loadingForSaving = true;
      this.loading = true;
      let requestData;
      if (this.activeSection === 'vouchers') {
        Object.assign(this.voucher, this.getCleanFormData());
        this.voucher.additionalFields = this.getMergedAdditionalFields();
        requestData = JSON.parse(JSON.stringify(this.voucher));
      } else {
        Object.assign(this.location, this.getCleanFormData());
        requestData = JSON.parse(JSON.stringify(this.location));
      }
      // Object.assign(this.location, this.getCleanFormData());
      // const requestData = JSON.parse(JSON.stringify(this.location));
      if (requestData.carousels != undefined && requestData.carousels.length > 0) {
        requestData.carousels.forEach((v: any) => {
          if (v.file) {
            delete v.file;
            v.image = '';
          }
        });
      }
      if (requestData.id == undefined) {
        requestData.image = '';
        requestData.additionalImage = '';
      }
      if (requestData.file) {
        requestData.image = '';
        delete requestData.file;
      }
      if (requestData.additionalFile) {
        requestData.additionalImage = '';
        delete requestData.additionalFile;
      }
      if (requestData.footerFile) {
        requestData.footerImage = '';
        delete requestData.footerFile;
      }
      if (requestData.iconFile) {
        requestData.icon = '';
        delete requestData.iconFile;
      }
      if (requestData.iconActiveFile) {
        requestData.iconActive = '';
        delete requestData.iconActiveFile;
      }
      if (requestData.events && requestData.events.length > 0) {
        requestData.events.filter((f: any) => f.file).forEach((v: any) => {
          delete v.file;
          v.image = '';
        });
      }
      if (requestData.additionalEvents && requestData.additionalEvents.length > 0) {
        requestData.additionalEvents.filter((f: any) => f.file).forEach((v: any) => {
          delete v.file;
          v.image = '';
        });
      }
      if (requestData.points && requestData.points.length > 0) {
        requestData.points.forEach((point: any) => {
          if (point.events) {
            point.events.filter((f: any) => f.file).forEach((v: any) => {
              delete v.file;
              v.image = '';
            });
          }
        });
      }
      if (this.activeSection === 'vouchers') {
        if (!this.voucher.id) {
          requestData.orderNumber = this.pagination.page.totalElements + 1;
        }
      } else {
        if (!this.location.id) {
          requestData.orderNumber = this.pagination.page.totalElements + 1;
        }
      }
      let id;
      if (this.activeSection === 'vouchers') {
        const request: VoucherDto = requestData;
        this.voucherService.saveVoucher(request).subscribe(async (data) => {
          id = data.id;
          this.getList();
          this.openItem(id);
          this.notificationService.implementNotification(new Notification({
            title: `Success`,
            text: `The ${this.getTitle()} \'${data.clientName}\' has been saved`,
            style: NotificationType.success
          }), 5000);
        });
      } else {
        this.saveEntity(requestData).subscribe(async (data) => {
          id = data.id;
          if (data.id && this.location.file) {
            const res = await lastValueFrom(this.saveMainPhoto(data.id, this.location.file));
            this.location.file = undefined;
            this.location.image = res.image;
          }
          if (data.id && this.location.footerFile) {
            const res = await lastValueFrom(this.saveFooterPhoto(data.id, this.location.footerFile));
            this.location.footerFile = undefined;
            this.location.footerImage = res.image;
          }
          if (data.id && this.location.iconFile) {
            const res = await lastValueFrom(this.saveCountryIcon(data.id, this.location.iconFile));
            this.location.iconFile = undefined;
            this.location.icon = res.icon;
          }

          if (data.id && this.location.iconActiveFile) {
            const res = await lastValueFrom(this.saveCountryIconActive(data.id, this.location.iconActiveFile));
            this.location.iconActiveFile = undefined;
            this.location.iconActive = res.iconActive;
          }
          if (data.id && this.location.additionalFile) {
            const res = await lastValueFrom(this.saveAdditionalPhoto(data.id, this.location.additionalFile));
            this.location.additionalFile = undefined;
            this.location.additionalImage = res.additionalImage;
          }

          const newCarouselsItems = this.location.carousels.filter(v => v.file);
          for (const v of newCarouselsItems) {
            let carouselInData;
            if (v.id) {
              carouselInData = data.carousels.find(d => v.id === d.id);
            } else {
              const carouselIndex = this.location.carousels.indexOf(v);
              carouselInData = data.carousels[carouselIndex];
            }
            v.id = carouselInData?.id;
            if (data.id && v.id != undefined && v.file) {
              const response = await lastValueFrom(this.saveCarouselPhoto(data.id, v.id, v.file));
              const idx = response.carousels.findIndex(d => d.id == v.id);
              if (idx > -1) {
                this.location.carousels[idx].image = response.carousels[idx].image;
                this.location.carousels[idx].file = undefined;
              }
            }
          }

          const toDeleteCarouselsItems = this.location.carousels.filter(v => v.toDelete);
          toDeleteCarouselsItems.forEach(v => {
            let carouselInData;
            if (v.id) {
              carouselInData = data.carousels.find(d => v.id === d.id);
            } else {
              const carouselIndex = this.location.carousels.indexOf(v);
              carouselInData = data.carousels[carouselIndex];
            }
            v.id = carouselInData?.id;
            if (data.id && v.id) {
              this.deleteCarouselEntity(data.id, v.id).subscribe(() => {
                const idxToDel = this.location.carousels.findIndex(c => c.id === v.id);
                if (idxToDel > -1) {
                  this.location.carousels.splice(idxToDel, 1);
                }
              });
            }
          });

          const newLocationsItems = this.location.events.filter(v => v.file);
          for (const v of newLocationsItems) {
            let eventInData;
            if (v.id) {
              eventInData = data.events.find(d => v.id === d.id);
            } else {
              const eventIndex = this.location.events.indexOf(v);
              eventInData = data.events[eventIndex];
            }
            v.id = eventInData?.id;
            if (data.id && v.id != undefined && v.file) {
              const response = await lastValueFrom(this.saveEventsPhoto(data.id, v.id, v.file));
              const idx = response.events.findIndex(d => d.id == v.id);
              if (idx > -1) {
                this.location.events[idx].image = response.events[idx].image;
                this.location.events[idx].file = undefined;
              }
            }
          }

          const toDeleteLocationsItems = this.location.events.filter(v => v.toDelete);
          toDeleteLocationsItems.forEach(v => {
            let eventInData;
            if (v.id) {
              eventInData = data.events.find(d => v.id === d.id);
            } else {
              const eventIndex = this.location.events.indexOf(v);
              eventInData = data.events[eventIndex];
            }
            v.id = eventInData?.id;
            if (data.id && v.id) {
              this.deleteEventEntity(data.id, v.id).subscribe(() => {
                const idxToDel = this.location.events.findIndex(c => c.id === v.id);
                if (idxToDel > -1) {
                  this.location.events.splice(idxToDel, 1);
                }
              });
            }
          });

          const newAdditionalLocationsItems = this.location.additionalEvents.filter(v => v.file);
          for (const v of newAdditionalLocationsItems) {
            let eventInData;
            if (v.id) {
              eventInData = data.additionalEvents.find(d => v.id === d.id);
            } else {
              const eventIndex = this.location.additionalEvents.indexOf(v);
              eventInData = data.additionalEvents[eventIndex];
            }
            v.id = eventInData?.id;
            if (data.id && v.id != undefined && v.file) {
              const response = await lastValueFrom(this.saveAdditionalEventsPhoto(data.id, v.id, v.file));
              const idx = response.additionalEvents.findIndex(d => d.id == v.id);
              if (idx > -1) {
                this.location.additionalEvents[idx].image = response.additionalEvents[idx].image;
                this.location.additionalEvents[idx].file = undefined;
              }
            }
          }

          const toDeleteAdditionalLocationsItems = this.location.additionalEvents.filter(v => v.toDelete);
          toDeleteAdditionalLocationsItems.forEach(v => {
            let eventInData;
            if (v.id) {
              eventInData = data.additionalEvents.find(d => v.id === d.id);
            } else {
              const eventIndex = this.location.additionalEvents.indexOf(v);
              eventInData = data.additionalEvents[eventIndex];
            }
            v.id = eventInData?.id;
            if (data.id && v.id) {
              this.deleteAdditionalEventEntity(data.id, v.id).subscribe(() => {
                const idxToDel = this.location.additionalEvents.findIndex(c => c.id === v.id);
                if (idxToDel > -1) {
                  this.location.additionalEvents.splice(idxToDel, 1);
                }
              });
            }
          });



          for (const point of this.location.points) {
            const pointIndex = this.location.points.indexOf(point);
            const pointInData = data.points[pointIndex];
            const toDeletePointEventItems = point.events.filter(v => v.toDelete);
            for (let i = toDeletePointEventItems.length - 1; i >= 0; i--) {
              const event = toDeletePointEventItems[i];
              let eventInData;
              if (event.id) {
                eventInData = pointInData?.events?.find(d => d.id === event.id);
              } else {
                const eventIndex = point.events.indexOf(event);
                eventInData = pointInData?.events?.[eventIndex];
              }
              event.id = eventInData?.id;
              if (data.id && pointInData?.id && event.id) {
                await lastValueFrom(this.deletePointEventEntity(data.id, pointInData.id, event.id));
                const eventIndex = point.events.findIndex(e => e.id === event.id);
                if (eventIndex > -1) {
                  point.events.splice(eventIndex, 1);
                }
              } else if (!event.id) {
                const eventIndex = point.events.indexOf(event);
                if (eventIndex > -1) {
                  point.events.splice(eventIndex, 1);
                }
              }
            }
          }

          const toDeletePointItems = this.location.points.filter(v => v.toDelete);
          for (let i = toDeletePointItems.length - 1; i >= 0; i--) {
            const point = toDeletePointItems[i];
            let pointInData;
            if (point.id) {
              pointInData = data.points.find(p => p.id === point.id);
            } else {
              const pointIndex = this.location.points.indexOf(point);
              pointInData = data.points[pointIndex];
            }

            point.id = pointInData?.id;
            if (data.id && point.id) {
              await lastValueFrom(this.deletePoint(data.id, point.id));
              const pointIndex = this.location.points.findIndex(p => p.id === point.id);
              if (pointIndex > -1) {
                this.location.points.splice(pointIndex, 1);
              }
            } else {
              const pointIndex = this.location.points.indexOf(point);
              if (pointIndex > -1) {
                this.location.points.splice(pointIndex, 1);
              }
            }
          }

          for (const point of this.location.points) {
            const pointIndex = this.location.points.indexOf(point);
            const pointInData = data.points[pointIndex];
            if (pointInData) {
              for (const event of point.events) {
                if (event.file) {
                  let eventInData;
                  if (event.id) {
                    eventInData = pointInData.events?.find(e => e.id === event.id);
                  } else {
                    const eventIndex = point.events.indexOf(event);
                    eventInData = pointInData.events?.[eventIndex];
                  }

                  if (eventInData) {
                    await this.savePointEventsPhoto(
                      data.id ?? 0,
                      pointInData.id ?? 0,
                      eventInData.id ?? 0,
                      event.file
                    );
                  }
                }
              }
            }
          }
          this.voucherTypes = [];
          this.voucherTypeNg = '';
          this.voucher = new VoucherDto();
          this.location.points = [];
          this.getList();
          this.openItem(id);
          this.notificationService.implementNotification(new Notification({
            title: `Success`,
            text: `The ${this.getTitle()} \'${data.titleEn}\' has been saved`,
            style: NotificationType.success
          }), 5000);
        });
      }
    }
  }


  getMoveUpService(id: number, entityId?: number) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.moveUp(id);
      }
      case 'countries': {
        return this.countryService.moveUp(id);
      }
      case 'cities': {
        return this.cityService.moveUp(id);
      }
      case 'hotels': {
        return this.hotelService.moveUp(id);
      }
      case 'adventures': {
        return this.continentService.moveUp(id);
      }
      case 'routes': {
        return this.routeService.moveUpPoint(id, entityId ?? 0);
      }
      case 'vouchers': {
        return this.routeService.moveUpPoint(id, entityId ?? 0);
      }
    }
  }

  moveUp(id: number, entityId?: number) {
    let x = 0;
    if (entityId) {
      x = entityId
    }
    this.getMoveUpService(id, x).subscribe((success) => {
      if (success) {
        this.getList();
        this.notificationService.implementNotification(new Notification({
          title: 'The order has been changed',
          text: 'The item has been moved up',
          style: NotificationType.info
        }), 5000);
      } else {
        this.notificationService.implementNotification(new Notification({
          title: 'The order hasn\'t been changed',
          text: 'The item has already been on the top of the list',
          style: NotificationType.warning
        }), 5000);
      }
    });
  }

  getMoveDownService(id: number, entityId?: number) {
    switch (this.activeSection) {
      case 'continents': {
        return this.continentService.moveDown(id);
      }
      case 'countries': {
        return this.countryService.moveDown(id);
      }
      case 'cities': {
        return this.cityService.moveDown(id);
      }
      case 'hotels': {
        return this.hotelService.moveDown(id);
      }
      case 'adventures': {
        return this.hotelService.moveDown(id);
      }
      case 'routes': {
        return this.routeService.moveDownPoint(id, entityId ?? 0)
      }
      case 'vouchers': {
        return this.routeService.moveDownPoint(id, entityId ?? 0)
      }
    }
  }

  moveDown(id: number) {
    this.getMoveDownService(id).subscribe((success) => {
      if (success) {
        this.getList();
        this.notificationService.implementNotification(new Notification({
          title: 'The order has been changed',
          text: 'The item has been moved down',
          style: NotificationType.info
        }), 5000);
      } else {
        this.notificationService.implementNotification(new Notification({
          title: 'The order hasn\'t been changed',
          text: 'The item has already been on the bottom of the list',
          style: NotificationType.warning
        }), 5000);
      }
    });
  }

  onFileChange() {
    const input = this.fileInput.nativeElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (file.type.startsWith('image/')) {
        this.errorMessage = null;
        const reader = new FileReader();
        reader.onload = () => {
          this.imageUrl = reader.result as string;
          switch (this.fileChangeType) {
            case "main": {
              this.addMainPhoto(file);
              break;
            }
            case "continent": {
              this.addItemCarousels(file);
              break;
            }
            case "additional": {
              this.addAdditionalPhoto(file);
              break;
            }
            case "event": {
              this.addEventImage(file);
              break;
            }
            case "additionalEvent": {
              this.addAdditionalEventImage(file);
              break;
            }
            case "footer": {
              this.addFooterPhoto(file);
              break;
            }
            case "icon": {
              this.addIconPhoto(file);
              break;
            }
            case "iconActive": {
              this.addIconActivePhoto(file);
              break;
            }
            case "point": {
              this.addPointImage(file);
              break;
            }
            case "pointEvent": {
              this.addPointEventImage(file);
              break;
            }
          }
        };
        reader.readAsDataURL(file);
        this.fileReset();
      } else {
        this.errorMessage = 'Пожалуйста, выберите файл изображения.';
        this.imageUrl = null;
      }
    }
  }

  fileReset() {
    this.fileInput.nativeElement.value = '';
  }

  onClickCarousels(type: 'main' | 'continent' | 'additional' | 'footer' | 'icon' | 'iconActive', id?: number) {
    this.fileChangeType = type;
    switch (type) {
      case "main": {
        break;
      }
      case "continent": {
        if (id != undefined && id > -1) {
          this.carouselActiveIdx = id;
        }
        break;
      }
      case "additional": {
        break;
      }
      case "footer": {
        break;
      }
      case "icon" : {
        break;
      }
      case "iconActive" : {
        break;
      }
    }
    this.fileInput.nativeElement.click();
  }

  addCarousels() {
    const newC = new Carousel();
    newC.orderNumber = this.location.carousels.length > 0
      ? Math.max(...this.location.carousels.map(v => v.orderNumber)) + 1
      : 0;
    this.location.carousels.push(newC);
  }

  deleteCarousel(idx: number) {
    this.location.carousels[idx].toDelete = true;
  }

  addItemCarousels(file: File) {
    if (this.imageUrl) {
      const item = this.carouselActiveIdx != undefined
        ? this.location.carousels[this.carouselActiveIdx]
        : new Carousel();
      item.image = this.imageUrl;
      item.file = file;
      this.imageUrl = null;
      if (this.carouselActiveIdx == undefined) {
        const list = this.location.carousels.map(v => v.orderNumber ?? -1);
        const max = list.length > 0 ? Math.max(...list) : -1;
        item.orderNumber = max + 1;
        this.location.carousels.push(item);
      }
      this.carouselActiveIdx = null;
    }
  }

  addMainPhoto(file: File) {
    if (this.imageUrl) {
      this.location.image = this.imageUrl;
      this.location.file = file;
    }
  }

  addAdditionalPhoto(file: File) {
    if (this.imageUrl) {
      this.location.additionalImage = this.imageUrl;
      this.location.additionalFile = file;
    }
  }

  addFooterPhoto(file: File) {
    if (this.imageUrl) {
      this.location.footerImage = this.imageUrl;
      this.location.footerFile = file;
    }
  }

  addIconPhoto(file: File) {
    if (this.imageUrl) {
      this.location.icon = this.imageUrl;
      this.location.iconFile = file;
    }
  }

  addIconActivePhoto(file: File) {
    if (this.imageUrl) {
      this.location.iconActive = this.imageUrl;
      this.location.iconActiveFile = file;
    }
  }

  getImgUrlMain(location: LocationDto) {
    return location.file ? location.image : environment.s3Prefix + location.image;
  }

  getImgUrlAdd(location: LocationDto) {
    return location.additionalFile ? location.additionalImage : environment.s3Prefix + location.additionalImage;
  }

  getImgUrlCarousel(carousel: Carousel) {
    return carousel.file ? carousel.image : environment.s3Prefix + carousel.image;
  }

  getImgUrlEvent(event: Events) {
    return event.file ? event.image : environment.s3Prefix + event.image;
  }

  getImgUrlFooter(location: LocationDto) {
    return location.footerFile ? location.footerImage : environment.s3Prefix + location.footerImage;
  }

  getImgUrlIcon(location: LocationDto) {
    return location.iconFile ? location.icon : environment.s3Prefix + location.icon;
  }

  getImgUrlIconActive(location: LocationDto) {
    return location.iconActiveFile ? location.iconActive : environment.s3Prefix + location.iconActive;
  }

  openItem(id?: number) {
    this.loading = true;
    window.scroll(0, 0);
    this.editMode = 'item';
    if (id) {
      this.displayPreview = false;
      switch (this.activeSection) {
        case 'continents': {
          this.continentService.getContinent(id).subscribe((data) => {
            this.loading = false;
            this.location = new LocationDto(data);
            this.pos = this.location.carousels.map(v => this.getCssPosition(v.cssStyle));
            this.linkPos = this.location.carousels.map(v => this.getCssLink(v.cssStyle));
            this.iconPos1 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 1));
            this.iconPos2 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 2));
            this.iconPos3 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 3));
            this.textPosEn1 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 1, 'En'));
            this.textPosEn2 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 2, 'En'));
            this.textPosEn3 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 3, 'En'));
            this.textPosRu1 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 1, 'Ru'));
            this.textPosRu2 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 2, 'Ru'));
            this.textPosRu3 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 3, 'Ru'));
            this.eventPos = this.location.events.map(v => this.getCssBackgroundPosition(v.cssStyle ?? ''));
            this.additionalEventPos = this.location.additionalEvents.map(v => this.getCssBackgroundPosition(v.cssStyle ?? ''));
            this.mainPos = this.getCssPosition(this.location.cssStyleImage ?? '');
            this.footerPos = this.getCssPosition(this.location.cssStyleFooterImage ?? '');
            this.myForm.patchValue(this.location);
          });
          break;
        }
        case 'countries' : {
          this.countryService.getCountry(id).subscribe((data) => {
            this.continentService.getContinentList(this.paramsList).subscribe((continents) => {
              this.options = continents.content || [];
              this.loading = false;
              this.location = new LocationDto(data);
              this.pos = this.location.carousels.map(v => this.getCssPosition(v.cssStyle));
              this.linkPos = this.location.carousels.map(v => this.getCssLink(v.cssStyle));
              this.iconPos1 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 1));
              this.iconPos2 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 2));
              this.iconPos3 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 3));
              this.textPosEn1 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 1, 'En'));
              this.textPosEn2 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 2, 'En'));
              this.textPosEn3 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 3, 'En'));
              this.textPosRu1 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 1, 'Ru'));
              this.textPosRu2 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 2, 'Ru'));
              this.textPosRu3 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 3, 'Ru'));
              this.eventPos = this.location.events.map(v => this.getCssBackgroundPosition(v.cssStyle ?? ''));
              this.additionalEventPos = this.location.additionalEvents.map(v => this.getCssBackgroundPosition(v.cssStyle ?? ''));
              this.mainPos = this.getCssPosition(this.location.cssStyleImage ?? '');
              this.footerPos = this.getCssPosition(this.location.cssStyleFooterImage ?? '');
              this.additionalPos = this.getCssBackgroundPosition(this.location.cssStyleAdditionalImage ?? '');
              this.myForm.patchValue(this.location);
            })
          });
          break;
        }
        case 'cities' : {
          this.countryService.getCountryList(this.paramsList).subscribe((countries) => {
            this.options = countries.content || [];
            this.cityService.getCity(id).subscribe((data) => {
              this.loading = false;
              this.location = new LocationDto(data);
              this.pos = this.location.carousels.map(v => this.getCssPosition(v.cssStyle));
              this.linkPos = this.location.carousels.map(v => this.getCssLink(v.cssStyle));
              this.iconPos1 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 1));
              this.iconPos2 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 2));
              this.iconPos3 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 3));
              this.textPosEn1 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 1, 'En'));
              this.textPosEn2 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 2, 'En'));
              this.textPosEn3 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 3, 'En'));
              this.textPosRu1 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 1, 'Ru'));
              this.textPosRu2 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 2, 'Ru'));
              this.textPosRu3 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 3, 'Ru'));
              this.eventPos = this.location.events.map(v => this.getCssBackgroundPosition(v.cssStyle ?? ''));
              this.additionalEventPos = this.location.additionalEvents.map(v => this.getCssBackgroundPosition(v.cssStyle ?? ''));
              this.mainPos = this.getCssPosition(this.location.cssStyleImage ?? '');
              this.footerPos = this.getCssPosition(this.location.cssStyleFooterImage ?? '');
              this.myForm.patchValue(this.location);
            });
          });
          break;
        }
        case 'hotels' : {
          this.cityService.getCityList(this.paramsList).subscribe((cities) => {
            this.options = cities.content || [];
            this.hotelService.getHotel(id).subscribe((data) => {
              this.adventuresService.getAdventureList(this.paramsListHotelsAdventures).subscribe((adventures) => {
                this.hotelAdventuresList = adventures.content ?? [];
                this.loading = false;
                this.location = new LocationDto(data);
                // this.hotelAdventuresList = this.location.adventures;
                this.mainPos = this.getCssPosition(this.location.cssStyleImage ?? '');
                this.footerPos = this.getCssPosition(this.location.cssStyleFooterImage ?? '');
                this.myForm.patchValue(this.location);
                this.displayPreview = true;
              });
            });
          })
          break;
        }
        case 'adventures' : {
          this.adventuresService.getAdventure(id).subscribe((data) => {
            this.loading = false;
            this.location = new LocationDto(data);
            this.pos = this.location.carousels.map(v => this.getCssPosition(v.cssStyle));
            this.eventPos = this.location.events.map(v => this.getCssBackgroundPosition(v.cssStyle ?? ''));
            this.additionalEventPos = this.location.additionalEvents.map(v => this.getCssBackgroundPosition(v.cssStyle ?? ''));
            this.mainPos = this.getCssPosition(this.location.cssStyleImage ?? '');
            this.footerPos = this.getCssPosition(this.location.cssStyleFooterImage ?? '');
            this.myForm.patchValue(this.location);
            this.displayPreview = true;
          });
          break;
        }
        case 'routes' : {
          this.routeService.getRoute(id).subscribe((data) => {
            this.cityService.getCityList(this.paramsListPointsCities).subscribe((cities) => {
              this.PointsCityList = cities.content ?? [];
              this.loading = false;
              this.location = new LocationDto(data);
              this.pos = this.location.carousels.map(v => this.getCssPosition(v.cssStyle));
              this.linkPos = this.location.carousels.map(v => this.getCssLink(v.cssStyle));
              this.iconPos1 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 1));
              this.iconPos2 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 2));
              this.iconPos3 = this.location.carousels.map(v => this.getCssIcon(v.cssStyle, 3));
              this.textPosEn1 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 1, 'En'));
              this.textPosEn2 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 2, 'En'));
              this.textPosEn3 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 3, 'En'));
              this.textPosRu1 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 1, 'Ru'));
              this.textPosRu2 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 2, 'Ru'));
              this.textPosRu3 = this.location.carousels.map(v => this.getCssText(v.cssStyle, 3, 'Ru'));
              this.eventPos = this.location.events.map(v => this.getCssBackgroundPosition(v.cssStyle ?? ''));
              this.additionalEventPos = this.location.additionalEvents.map(v => this.getCssBackgroundPosition(v.cssStyle ?? ''));
              this.mainPos = this.getCssPosition(this.location.cssStyleImage ?? '');
              this.footerPos = this.getCssPosition(this.location.cssStyleFooterImage ?? '');
              if (!this.location.points) this.location.points = [];
              this.location.points.forEach((point, index) => {
                if (!point.cities) point.cities = [];
                if (!point.events) point.events = [];
                this.selectedCityForPoint[index] = '';
                point.events.forEach((event, idx) => {
                  event.orderNumber = event.orderNumber ?? idx;
                });
                if (!this.innerPos[index]) {
                  this.innerPos[index] = [];
                }
                this.innerPos[index] = point.events.map(v => this.getCssBackgroundPosition(v.cssStyle ?? ''));
              });
              this.myForm.patchValue(this.location);
            });
          });
          break;
        }
        case 'vouchers': {
          this.voucherService.getVoucher(id).subscribe((data) => {
            this.voucherService.getVoucherTemplates().subscribe((voucherTemplates) => {
            // this.voucherService.getVoucherTemplate(this.defaultParams).subscribe((voucherTemplate) => {
              this.voucherTypes = voucherTemplates ?? [];
              this.voucher = new VoucherDto(data);
              this.location.titleEn = this.voucher.clientName ?? '';
              this.myForm.patchValue(this.voucher);
              const voucherTemp = this.voucherTypes.find((v) => v.name === this.voucher.type);
              this.voucherTypeNg = this.voucher.type ?? '';
              this.setVoucherType(this.voucher.type);
              this.voucherService.getVoucherStream(id, voucherTemp?.id ?? 0).subscribe((temp: any) => {
                this.pdfUrl = URL.createObjectURL(temp);
                this.loading = false;
              })
            })
            // const voucherTemplate: VoucherTemplate[] = [
            //         // {
            //         //     "id": 0,
            //         //     "name": "COMMERCIAL_PROPOSAL",
            //         //     "file": "voucher-templates/0/commercial-proposal.jrxml",
            //         //   "fields": [],
            //         //   "active": true,
            //         // },
            //         {
            //             "id": 1,
            //             "name": "HOTEL_BOOKING",
            //             "file": "voucher-templates/1/hotel-booking.jrxml",
            //           "fields": [
            //             {
            //               "title": "Client Name",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Hotel Name",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Hotel Confirmation Number",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Start date",
            //               "type": "DATE",
            //               "active": true
            //             },
            //             {
            //               "title": "End date",
            //               "type": "DATE",
            //               "active": true
            //             },
            //             {
            //               "title": "Check in time",
            //               "type": "TIME",
            //               "active": true
            //             },
            //             {
            //               "title": "Check out time",
            //               "type": "TIME",
            //               "active": true
            //             },
            //             {
            //               "title": "Accommodation",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Meal plan",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Hotel Address",
            //               "type": "STRING",
            //               "active": true
            //             },
            //           ],
            //           "active": true,
            //         },
            //         {
            //             "id": 2,
            //             "name": "AIRPORT_SERVICE",
            //             "file": "voucher-templates/2/airport-service.jrxml",
            //           "fields": [
            //             {
            //               "title": "Departure Client’s name",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Departure Airport Name",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Departure Service Name",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Departure Flight Date",
            //               "type": "DATE",
            //               "active": true
            //             },
            //             {
            //               "title": "Departure Flight Time",
            //               "type": "TIME",
            //               "active": true
            //             },
            //             {
            //               "title": "Departure Flight Number",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Transit Client’s name",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Transit Airport Name",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Transit Service Name",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Transit Flight Date",
            //               "type": "DATE",
            //               "active": true
            //             },
            //             {
            //               "title": "Transit Flight Time",
            //               "type": "TIME",
            //               "active": true
            //             },
            //             {
            //               "title": "Transit Flight Number",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Arrival Client’s name",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Arrival Airport Name",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Arrival Service Name",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Arrival Flight Date",
            //               "type": "DATE",
            //               "active": true
            //             },
            //             {
            //               "title": "Arrival Flight Time",
            //               "type": "TIME",
            //               "active": true
            //             },
            //             {
            //               "title": "Arrival Flight Number",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Transfer Pick up Date",
            //               "type": "DATE",
            //               "active": true
            //             },
            //             {
            //               "title": "Transfer Pick up time",
            //               "type": "TIME",
            //               "active": true
            //             },
            //             {
            //               "title": "Transfer Pick up Number",
            //               "type": "STRING",
            //               "active": true
            //             },
            //             {
            //               "title": "Car & Route",
            //               "type": "STRING",
            //               "active": true
            //             }
            //           ],
            //           "active": true,
            //         },
            //         // {
            //         //     "id": 3,
            //         //     "name": "OTHER_SERVICE",
            //         //     "file": "voucher-templates/3/other-service.jrxml",
            //         //   "fields": [],
            //         //   "active": true,
            //         // }
            // ];
            // this.voucherTypes = voucherTemplate;
          })
          break;
        }
      }
      if (this.descriptionEn?.nativeElement) {
        setTimeout(() => {
          this.onInput(this.descriptionEn.nativeElement);
        }, 500);
      }
    } else {
      this.displayPreview = true;
      this.loading = false;
      this.myForm.reset();
      this.location = new LocationDto();
      if (this.activeSection === 'routes') {
        this.cityService.getCityList(this.paramsListPointsCities).subscribe((cities) => {
          this.PointsCityList = cities.content ?? [];
        });
      }
      if (this.activeSection === 'hotels') {
        this.cityService.getCityList(this.paramsList).subscribe((cities) => {
          this.options = cities.content || [];
        });
        this.adventuresService.getAdventureList(this.paramsListHotelsAdventures).subscribe((adventures) => {
          this.hotelAdventuresList = adventures.content ?? [];
        });
      }
      if (this.activeSection === 'vouchers') {
        // const voucherTemplate: VoucherTemplate[] = [
        //   // {
        //   //   "id": 0,
        //   //   "name": "COMMERCIAL_PROPOSAL",
        //   //   "file": "voucher-templates/0/commercial-proposal.jrxml",
        //   //   "fields": [],
        //   //   "active": true,
        //   // },
        //   {
        //     "id": 1,
        //     "name": "HOTEL_BOOKING",
        //     "file": "voucher-templates/1/hotel-booking.jrxml",
        //     "fields": [
        //       {
        //         "title": "Client Name",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Hotel Name",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Hotel Confirmation Number",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Start date",
        //         "type": "DATE",
        //         "active": true
        //       },
        //       {
        //         "title": "End date",
        //         "type": "DATE",
        //         "active": true
        //       },
        //       {
        //         "title": "Check in time",
        //         "type": "TIME",
        //         "active": true
        //       },
        //       {
        //         "title": "Check out time",
        //         "type": "TIME",
        //         "active": true
        //       },
        //       {
        //         "title": "Accommodation",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Meal plan",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Hotel Address",
        //         "type": "STRING",
        //         "active": true
        //       },
        //     ],
        //     "active": true,
        //   },
        //   {
        //     "id": 2,
        //     "name": "AIRPORT_SERVICE",
        //     "file": "voucher-templates/2/airport-service.jrxml",
        //     "fields": [
        //       {
        //         "title": "Departure Client’s name",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Departure Airport Name",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Departure Service Name",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Departure Flight Date",
        //         "type": "DATE",
        //         "active": true
        //       },
        //       {
        //         "title": "Departure Flight Time",
        //         "type": "TIME",
        //         "active": true
        //       },
        //       {
        //         "title": "Departure Flight Number",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Transit Client’s name",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Transit Airport Name",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Transit Service Name",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Transit Flight Date",
        //         "type": "DATE",
        //         "active": true
        //       },
        //       {
        //         "title": "Transit Flight Time",
        //         "type": "TIME",
        //         "active": true
        //       },
        //       {
        //         "title": "Transit Flight Number",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Arrival Client’s name",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Arrival Airport Name",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Arrival Service Name",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Arrival Flight Date",
        //         "type": "DATE",
        //         "active": true
        //       },
        //       {
        //         "title": "Arrival Flight Time",
        //         "type": "TIME",
        //         "active": true
        //       },
        //       {
        //         "title": "Arrival Flight Number",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Transfer Pick up Date",
        //         "type": "DATE",
        //         "active": true
        //       },
        //       {
        //         "title": "Transfer Pick up time",
        //         "type": "TIME",
        //         "active": true
        //       },
        //       {
        //         "title": "Transfer Pick up Number",
        //         "type": "STRING",
        //         "active": true
        //       },
        //       {
        //         "title": "Car & Route",
        //         "type": "STRING",
        //         "active": true
        //       }
        //     ],
        //     "active": true,
        //   },
        //   // {
        //   //   "id": 3,
        //   //   "name": "OTHER_SERVICE",
        //   //   "file": "voucher-templates/3/other-service.jrxml",
        //   //   "fields": [],
        //   //   "active": true,
        //   // }
        // ];
        // this.voucherTypes = voucherTemplate;
        // this.voucherTypeNg = '';
        // this.voucher = new VoucherDto();
        // this.voucherCustomFields = [];
        this.voucher.additionalFields = [];
        this.voucherCustomFields = [];
        this.voucherTemplateFields = [];
        this.voucherTypes = [];
        this.voucherService.getVoucherTemplates().subscribe((voucherTemplates) => {
        // this.voucherService.getVoucherTemplate(this.defaultParams).subscribe((voucherTemplate) => {
          this.voucherTypeNg = '';
          this.voucherTypes = voucherTemplates ?? [];
          this.voucher = new VoucherDto();
        })
      }
    }
    setTimeout(() => {
      this.loadingForSaving = false;
    }, 5000);
  }

  getCorrectVoucherType() {
    return this.voucherTypeNg === 'HOTEL_BOOKING' ||
      this.voucherTypeNg === 'AIRPORT_SERVICE' ||
      this.voucherTypeNg === 'OTHER_SERVICE';
  }

  splitAdditionalFieldsOnLoad(voucher: VoucherDto): void {
    this.setVoucherType(voucher.type);
  }

  getInnerPos(j: number, i: number) {
    if (!this.innerPos[j] || !this.innerPos[j][i]) {
      return '';
    }
    return this.innerPos[j][i];
  }

  setInnerPos(value: string, j: number, i: number) {
    if (!this.innerPos[j]) {
      this.innerPos[j] = [];
    }
    this.innerPos[j][i] = value;
    this.setCssPosition(value, 'innerEvent', j, i);
  }


  sorting(sort: string) {
    this.params.sort = sort;
    this.params.pageNumber = 0;
    this.settings.paginationParams = this.params;
    this.settings.currentSortHeader = this.currentSortHeader;
    this.settings.currentSort = this.currentSort;
    this.adminSettings.setAdminSetting(this.settings);
    this.getList();
  }

  setCurrentSortHeader(value: string) {
    this.currentSortHeader = value;
    this.settings.currentSortHeader = value;
    this.adminSettings.setAdminSetting(this.settings);
  }

  setCurrentSort(value: string) {
    this.currentSort = value;
    this.settings.currentSort = value;
    this.adminSettings.setAdminSetting(this.settings);
  }

  deleteItem(location: LocationDto, voucher: VoucherDto) {
    if (this.activeSection === 'vouchers') {
      if (voucher.id) {
        this.voucherService.delete(voucher.id).subscribe(() => {
          this.notificationService.implementNotification(new Notification({
            title: `Success`,
            text: `The ${this.getTitle()} \'${voucher.type}\' has been deleted`,
            style: NotificationType.error
          }), 5000);
          this.back();
        })
      }
    } else {
      if (location.id) {
        switch (this.activeSection) {
          case 'continents': {
            this.continentService.delete(location.id).subscribe(() => {
              this.notificationService.implementNotification(new Notification({
                title: `Success`,
                text: `The ${this.getTitle()} \'${location.titleEn}\' has been deleted`,
                style: NotificationType.error
              }), 5000);
              this.back();
            });
            break;
          }
          case 'countries': {
            this.countryService.delete(location.id).subscribe(() => {
              this.notificationService.implementNotification(new Notification({
                title: `Success`,
                text: `The ${this.getTitle()} \'${location.titleEn}\' has been deleted`,
                style: NotificationType.error
              }), 5000);
              this.back();
            });
            break;
          }
          case 'cities': {
            this.cityService.delete(location.id).subscribe(() => {
              this.notificationService.implementNotification(new Notification({
                title: `Success`,
                text: `The ${this.getTitle()} \'${location.titleEn}\' has been deleted`,
                style: NotificationType.error
              }), 5000);
              this.back();
            });
            break;
          }
          case 'hotels': {
            this.hotelService.delete(location.id).subscribe(() => {
              this.notificationService.implementNotification(new Notification({
                title: `Success`,
                text: `The ${this.getTitle()} \'${location.titleEn}\' has been deleted`,
                style: NotificationType.error
              }), 5000);
              this.back();
            });
            break;
          }
          case 'adventures': {
            this.adventuresService.delete(location.id).subscribe(() => {
              this.notificationService.implementNotification(new Notification({
                title: `Success`,
                text: `The ${this.getTitle()} \'${location.titleEn}\' has been deleted`,
                style: NotificationType.error
              }), 5000);
              this.back();
            });
            break;
          }
          case 'routes': {
            this.routeService.delete(location.id).subscribe(() => {
              this.notificationService.implementNotification(new Notification({
                title: `Success`,
                text: `The ${this.getTitle()} \'${location.titleEn}\' has been deleted`,
                style: NotificationType.error
              }), 5000);
              this.back();
            });
            break;
          }
        }
      }
    }
  }

  searching() {
    if (this.search.length > 2) {
      this.params.pageNumber = 0;
      this.params.query = this.search;
      this.settings.search = this.search;
      this.settings.paginationParams = this.params;
      this.adminSettings.setAdminSetting(this.settings);
      this.getList();
    } else {
      this.search = "";
      this.params.query = this.search;
      this.settings.search = this.search;
      this.adminSettings.setAdminSetting(this.settings);
      this.getList();
    }
  }

  clearSearch() {
    this.continentFilterId = null;
    this.countryFilterId = null;
    this.search = '';
    this.params.query = '';
    this.params.pageNumber = 0;
    this.params.sort = '';
    this.params.continentId = '';
    this.params.countryId = '';
    this.params.cityId = '';
    this.settings.currentSortHeader = '';
    this.settings.currentSort = '';
    this.currentSort = this.settings.currentSort;
    this.currentSortHeader = this.settings.currentSortHeader;
    this.clearFilters();
    this.settings.search = this.search;
    this.settings.paginationParams = this.params;
    this.adminSettings.setAdminSetting(this.settings);
    this.getClearSorting++;
    this.getList();
  }


  onInput(nativeElement: HTMLTextAreaElement) {
    nativeElement.style.height = 'auto'; // Сбрасываем высоту
    nativeElement.style.height = `${nativeElement.scrollHeight}px`; // Устанавливаем новую высоту
  }

  onInputEventTextArea(value: any, nativeElement: HTMLTextAreaElement, item: any) {
    nativeElement.style.height = 'auto'; // Сбрасываем высоту
    nativeElement.style.height = `${nativeElement.scrollHeight}px`; // Устанавливаем новую высоту
  }

  addEvent() {
    const item = new Events();
    const events = this.location.events;
    const maxOrderNumber = events.length > 0
      ? Math.max(...events.map(e => e.orderNumber ?? -1))
      : -1;
    item.orderNumber = maxOrderNumber + 1;
    events.push(item);
  }

  addPoint() {
    const item = new Points();
    const maxOrderNumber = this.location.points.length > 0
      ? Math.max(...this.location.points.map(p => p.orderNumber ?? -1))
      : -1;
    item.orderNumber = maxOrderNumber + 1;
    item.events = item.events || [];
    item.cities = item.cities || [];
    this.location.points.push(item);
    this.myForm.get('points')?.setValue([...this.location.points]);

    // Установить новую точку как активную вкладку
    this.activePointTab = this.location.points.length - 1;
  }

  addPointEvent(idx: number) {
    const item = new Events();
    const events = this.location.points[idx].events;
    const maxOrderNumber = events.length > 0
      ? Math.max(...events.map(e => e.orderNumber ?? -1))
      : -1;
    item.orderNumber = maxOrderNumber + 1;
    events.push(item);
  }

  deleteEvent(idx: number) {
    this.location.events[idx].toDelete = true;
  }

  deletePointEl(idx: number) {
    const point = this.location.points[idx];
    if (point.id !== undefined && point.id !== null) {
      point.toDelete = true;
    } else {
      this.location.points.splice(idx, 1);
      if (this.location.points.length === 0) {
        this.activePointTab = null;
      } else if (this.activePointTab !== null && this.activePointTab >= idx) {
        this.activePointTab = Math.max(0, this.activePointTab - 1);
      }
    }
    this.myForm.get('points')?.setValue([...this.location.points]);
    this.changeDetectorRef.detectChanges();
  }

  deletePointEvent(pointIndex: number, eventIndex: number) {
    const point = this.location.points[pointIndex];
    if (!point || !point.events) return;
    const event = point.events[eventIndex];
    if (!event) return;
    if (event.id !== undefined && event.id !== null) {
      event.toDelete = true;
    } else {
      point.events.splice(eventIndex, 1);
    }

    this.myForm.get('points')?.setValue([...this.location.points]);
    this.changeDetectorRef.detectChanges();
  }



  addAdditionalEvent() {
    const item = new Events();
    const additionalEvents = this.location.additionalEvents;
    const maxOrderNumber = additionalEvents.length > 0
      ? Math.max(...additionalEvents.map(e => e.orderNumber ?? -1))
      : -1;
    item.orderNumber = maxOrderNumber + 1;
    additionalEvents.push(item);
  }

  addAdditionalVoucherField() {
    const item = new AdditionalFields();
    this.voucherCustomFields.push(item);
  }

  deleteAdditionalVoucherField(index: number) {
    this.voucherCustomFields.splice(index, 1);
  }

  getMergedAdditionalFields(): AdditionalFields[] {
    const normalizedTemplateFields = this.voucherTemplateFields.map((field, index) => {
      const additionalField = new AdditionalFields();
      if (field.id) {
        additionalField.id = field.id;
      }
      additionalField.title = field.title;
      additionalField.value = field.value || '';
      additionalField.key = field.key;
      additionalField.type = field.type;
      additionalField.orderNumber = field.orderNumber !== undefined ? field.orderNumber : index;
      additionalField.active = true;
      return additionalField;
    });
    const templateOrderNumbers = normalizedTemplateFields
      .map(f => f.orderNumber || 0);
    const maxOrderNumber = templateOrderNumbers.length > 0
      ? Math.max(...templateOrderNumbers)
      : 0;
    const normalizedCustomFields = this.voucherCustomFields.map((field, index) => {
      const customField = new AdditionalFields(field);
      customField.type = 'STRING';
      customField.orderNumber = maxOrderNumber + index + 1;
      return customField;
    });
    return [...normalizedTemplateFields, ...normalizedCustomFields];
  }

  deleteAdditionalEvent(idx: number) {
    this.location.additionalEvents[idx].toDelete = true;
  }

  onClickEventImage(i: number) {
    this.eventActiveIdx = i;
    this.fileChangeType = 'event';
    this.fileInput.nativeElement.click();
  }

  onClickPointEventImage(j: number, i: number) {
    this.eventActivePointIdx = i;
    this.eventActivePointJIdx = j;
    this.fileChangeType = 'pointEvent';
    this.fileInput.nativeElement.click();
  }

  onClickPointImage(j: number) {
    this.ActivePointJIdx = j;
    this.fileChangeType = 'point';
    this.fileInput.nativeElement.click();
  }

  onClickAdditionalEventImage(i: number) {
    this.eventAdditionalActiveIdx = i;
    this.fileChangeType = 'additionalEvent';
    this.fileInput.nativeElement.click();
  }

  addEventImage(file: File) {
    if (this.eventActiveIdx != undefined && this.eventActiveIdx > -1) {
      this.location.events[this.eventActiveIdx].image = this.imageUrl ?? '';
      this.location.events[this.eventActiveIdx].file = file;
    }
  }

  addPointEventImage(file: File) {
    if (this.eventActivePointJIdx !== null && this.eventActivePointIdx !== null) {
      const point = this.location.points[this.eventActivePointJIdx];
      if (point) {
        const event = point.events[this.eventActivePointIdx];
        if (event) {
          event.image = this.imageUrl ?? '';
          event.file = file;
        }
      }
    }
    this.resetFileSelection();
  }

  resetFileSelection() {
    this.eventActivePointIdx = null;
    this.eventActivePointJIdx = null;
    this.imageUrl = null;
  }

  addAdditionalEventImage(file: File) {
    if (this.eventAdditionalActiveIdx != undefined && this.eventAdditionalActiveIdx > -1) {
      this.location.additionalEvents[this.eventAdditionalActiveIdx].image = this.imageUrl ?? '';
      this.location.additionalEvents[this.eventAdditionalActiveIdx].file = file;
    }
  }

  setGrayScale(event: Event, index: number, type: 'main' | 'additional' | 'carousel' | 'innerEvent' | 'mainPhoto' | 'footerPhoto' | 'additionalPhoto', additionalIndex?: number) {
    const input = event.target as HTMLInputElement;
    let value = parseInt(input.value, 10);
    if (isNaN(value)) {
      value = 0;
    } else if (value < 0) {
      value = 0;
    } else if (value > 100) {
      value = 100;
    }
    input.value = value.toString();
    switch (type) {
      case "main": {
        this.location.events[index].cssStyle = this.setCssStyle(this.location.events[index].cssStyle ?? '', 'grayscale', value);
        break;
      }
      case "additional": {
        this.location.additionalEvents[index].cssStyle = this.setCssStyle(this.location.additionalEvents[index].cssStyle ?? '', 'grayscale', value);
        break;
      }
      case "carousel": {
        this.location.carousels[index].cssStyle = this.setCssStyle(this.location.carousels[index].cssStyle ?? '', 'grayscale', value);
        break;
      }
      case "innerEvent": {
        if (additionalIndex != undefined) {
          this.location.points[index].events[additionalIndex].cssStyle = this.setCssStyle(this.location.points[index].events[additionalIndex].cssStyle ?? '', 'grayscale', value);
        }
        break;
      }
      case 'mainPhoto': {
        this.location.cssStyleImage = this.setCssStyle(this.location.cssStyleImage ?? '', 'grayscale', value);
        break;
      }
      case 'footerPhoto': {
        this.location.cssStyleFooterImage = this.setCssStyle(this.location.cssStyleFooterImage ?? '', 'grayscale', value);
        break;
      }
      case 'additionalPhoto': {
        this.location.cssStyleAdditionalImage = this.setCssStyle(this.location.cssStyleAdditionalImage ?? '', 'grayscale', value);
        break;
      }
    }
  }

  setCarouselCloudStyle(event: Event, index: number, type: 'top' | 'left') {
    const input = event.target as HTMLInputElement;
    let value = parseInt(input.value, 10);
    if (isNaN(value)) {
      value = 0;
    } else if (value < 0) {
      value = 0;
    } else if (value > 100) {
      value = 100;
    }
    input.value = value.toString();
    switch (type) {
      case "top": {
        this.location.carousels[index].cssStyle = this.setCssStyle(this.location.carousels[index].cssStyle ?? '', 'top', value);
        break;
      }
      case "left": {
        this.location.carousels[index].cssStyle = this.setCssStyle(this.location.carousels[index].cssStyle ?? '', 'left', value);
        break;
      }
    }
  }

  setCssPosition(value: any, type: 'mainImage' | 'footerImage' | 'additionalImage' | 'carousel' | 'carouselIcon' | 'carouselText' | 'carouselLink' | 'event' | 'additionalEvent' | 'innerEvent', index?: number, additionalIndex?: number, textType?: string) {
    switch (type) {
      case "mainImage": {
         this.location.cssStyleImage = this.setCssStyle(this.location.cssStyleImage ?? '', 'position', value);
        break;
      }
      case "footerImage": {
        this.location.cssStyleFooterImage = this.setCssStyle(this.location.cssStyleFooterImage ?? '', 'position', value);
        break;
      }
      case "additionalImage": {
        this.location.cssStyleAdditionalImage = this.setCssStyle(this.location.cssStyleAdditionalImage ?? '', 'background-position', value);
        break;
      }
      case "carousel": {
        if (index !== undefined) {
          this.location.carousels[index].cssStyle = this.setCssStyle(this.location.carousels[index].cssStyle ?? '', 'position', value);
        }
        break;
      }
      case "carouselIcon": {
        if (index !== undefined) {
          if (additionalIndex != undefined) {
            this.location.carousels[index].cssStyle = this.setCssStyle(this.location.carousels[index].cssStyle ?? '', 'icon', value, additionalIndex);
          }
        }
        break;
      }
      case "carouselText": {
        if (index !== undefined) {
          if (additionalIndex != undefined && textType != undefined) {
            this.location.carousels[index].cssStyle = this.setCssStyle(this.location.carousels[index].cssStyle ?? '', 'text', value, additionalIndex, textType);
          }
        }
        break;
      }
      case "carouselLink": {
        if (index !== undefined) {
          this.location.carousels[index].cssStyle = this.setCssStyle(this.location.carousels[index].cssStyle ?? '', 'link', value);
        }
        break;
      }
      case "event": {
        if (index !== undefined) {
          this.location.events[index].cssStyle = this.setCssStyle(this.location.events[index].cssStyle ?? '', 'background-position', value);
        }
        break;
      }
      case "additionalEvent": {
        if (index !== undefined) {
          this.location.additionalEvents[index].cssStyle = this.setCssStyle(this.location.additionalEvents[index].cssStyle ?? '', 'background-position', value);
        }
        break;
      }
      case "innerEvent": {
        if (additionalIndex != undefined && index !== undefined) {
          this.location.points[index].events[additionalIndex].cssStyle = this.setCssStyle(this.location.points[index].events[additionalIndex].cssStyle ?? '', 'background-position', value);
        }
        break
      }
    }
  }

  setVoucherType(value: any, clean?: boolean) {
    this.myForm.patchValue({
      type: value
    });

    const index = this.voucherTypes.findIndex(item => item.name === value);
    this.voucherActiveIdx = index !== -1 ? index : 0;
    const currentTemplate = this.voucherTypes[index];

    this.voucherTemplateFields = [];
    this.voucherCustomFields = [];

    if (currentTemplate?.fields && Array.isArray(currentTemplate.fields)) {
      // Нормализуем template fields - гарантируем что у всех есть orderNumber
      const normalizedTemplateFields = currentTemplate.fields.map((field: any, index: number) => ({
        ...field,
        orderNumber: field.orderNumber !== undefined ? field.orderNumber : index
      }));

      // Нормализуем existing fields - гарантируем что у всех есть orderNumber
      const normalizedExistingFields = (this.voucher.additionalFields || []).map((field, index) => ({
        ...field,
        orderNumber: field.orderNumber !== undefined ? field.orderNumber : index
      }));

      // Создаем карту существующих полей по orderNumber + title
      const existingFieldsMap = new Map();
      normalizedExistingFields.forEach(field => {
        const uniqueKey = `${field.orderNumber}_${field.title}`;
        existingFieldsMap.set(uniqueKey, field);
      });

      // Заполняем template fields значениями из существующих данных
      this.voucherTemplateFields = normalizedTemplateFields.map((field: any) => {
        const uniqueKey = `${field.orderNumber}_${field.title}`;
        const existingField = existingFieldsMap.get(uniqueKey);

        return {
          ...field,
          value: existingField?.value || '',
          id: existingField?.id // сохраняем ID если есть
        };
      });

      // Кастомные поля - те, которых нет в template fields
      this.voucherCustomFields = normalizedExistingFields.filter(field => {
        const uniqueKey = `${field.orderNumber}_${field.title}`;
        return !existingFieldsMap.has(uniqueKey) ||
          !normalizedTemplateFields.some(tf =>
            `${tf.orderNumber}_${tf.title}` === uniqueKey
          );
      });

    } else {
      this.voucherCustomFields = this.voucher.additionalFields || [];
    }

    if (clean !== undefined && clean) {
      this.voucherCustomFields = [];
      this.voucher.additionalFields = [];
    }
  }

  getCssPosition(css: string) {
    const arr = css.split(';').filter(item => item.trim() !== '');
    const idx = arr.findIndex(v => v.includes('object-position:'));
    return idx > -1 ? arr[idx].replace('object-position:', '').replaceAll(' ', '') : '';
  }

  getCssLink(css: string) {
    const arr = css.split(';').filter(item => item.trim() !== '');
    const idx = arr.findIndex(v => v.includes('link:'));
    return idx > -1 ? arr[idx].replace('link:', '').replaceAll(' ', '') : '';
  }

  getCssIcon(css: string, index: number) {
    const arr = css.split(';').filter(item => item.trim() !== '');
    const idx = arr.findIndex(v => v.includes(`icon${index}:`));
    return idx > -1 ? arr[idx].replace(`icon${index}:`, '').replaceAll(' ', '') : '';
  }

  getCssText(css: string, index: number, type: string) {
    const arr = css.split(';').filter(item => item.trim() !== '');
    const idx = arr.findIndex(v => v.includes(`text${type + index}:`));
    return  idx > -1 ? arr[idx].replace(`text${type + index}:`, '') : '';
  }

  getCssBackgroundPosition(css: string) {
    const arr = css.split(';').filter(item => item.trim() !== '');
    const idx = arr.findIndex(v => v.includes('background-position:'));
    return idx > -1 ? arr[idx].replace('background-position:', '').replaceAll(' ', '') : '';
  }

  getCssStyle(css: string, type: string) {
    const arr = css.split(';').filter(item => item.trim() !== '');
    switch (type) {
      case 'grayscale': {
        const idx = arr.findIndex(v => v.includes('filter: grayscale'));
        return idx > -1 ? arr[idx].replace(/\D/g, '') : '';
      }
      case 'position': {
        const idx = arr.findIndex(v => v.includes('align-items:'));
        return idx > -1 ? arr[idx].replace('align-items:', '') : '';
      }
      case 'top': {
        const idx = arr.findIndex(v => v.trim().startsWith('top:'));
        if (idx > -1) {
          return arr[idx].replace(/[^\d]/g, '');
        }
        return '';
      }
      case 'left': {
        const idx = arr.findIndex(v => v.trim().startsWith('left:'));
        if (idx > -1) {
          return arr[idx].replace(/[^\d]/g, '');
        }
        return '';
      }
      default: {
        return '';
      }
    }
  }

  setCssStyle(css: string, type: string, value: any, additionalIndex?: number, textType?: string) {
    const cleanCss = css.trim().replace(/^;+|;+$/g, '');
    const arr = cleanCss.split(';').filter(item => item.trim() !== '');
    switch (type) {
      case 'grayscale': {
        const idx = arr.findIndex(v => v.includes('filter: grayscale'));
        if (idx > -1) {
          arr[idx] = `filter: grayscale(${value}%)`;
          return arr.join(';') + ';';
        } else {
          return cleanCss + (cleanCss ? ';' : '') + `filter: grayscale(${value}%)` + ';';
        }
      }
      case 'position': {
        const idx = arr.findIndex(v => v.includes('object-position:'));
        if (idx > -1) {
          arr[idx] = `object-position: ${value}`;
          return arr.join(';') + ';';
        } else {
          return cleanCss + (cleanCss ? ';' : '') + `object-position: ${value}` + ';';
        }
      }
      case 'background-position': {
        const idx = arr.findIndex(v => v.includes('background-position:'));
        if (idx > -1 && value != undefined) {
          arr[idx] = `background-position: ${value}`;
          return arr.join(';') + ';';
        } else {
          return cleanCss + (cleanCss ? ';' : '') + `background-position: ${value}` + ';';
        }
      }
      case 'top': {
        const filteredArr = arr.filter(v => !v.trim().startsWith('top:'));
        filteredArr.push(`top: ${value}`);
        return filteredArr.join(';') + ';';
      }
      case 'left': {
        const filteredArr = arr.filter(v => !v.trim().startsWith('left:'));
        filteredArr.push(`left: ${value}`);
        return filteredArr.join(';') + ';';
      }
      case 'icon': {
        if (additionalIndex != undefined) {
          const filteredArr = arr.filter(v => !v.trim().startsWith(`icon${additionalIndex}:`));
          filteredArr.push(`icon${additionalIndex}: ${value}`);
          return filteredArr.join(';') + ';';
        } else return cleanCss + ';';
      }
      case 'text': {
        if (additionalIndex != undefined && textType != undefined) {
          const filteredArr = arr.filter(v => !v.trim().startsWith(`text${textType + additionalIndex}:`));
          filteredArr.push(`text${textType + additionalIndex}: ${value}`);
          return filteredArr.join(';') + ';';
        } else return cleanCss + ';';
      }
      case 'link': {
        const filteredArr = arr.filter(v => !v.trim().startsWith('link:'));
        filteredArr.push(`link: ${value}`);
        return filteredArr.join(';') + ';';
      }
      default: {
        return cleanCss + ';';
      }
    }
  }

  openPage() {
    let route = '';
    switch (this.activeSection) {
      case 'continents': {
        route = `/destinations/${this.location.url}`;
        break;
      }
      case 'countries': {
        route = `/destinations/${this.location.continent?.url}/${this.location.url}`;
        break;
      }
      case 'cities': {
        route = `/destinations/${this.location.country?.continent?.url}/${this.location.country?.url}/${this.location.url}`;
        break;
      }
      case 'hotels': {
        route = '/' + this.location.city?.country?.continent?.url + '/' + this.location.city?.country?.url + '/' +
          this.location.city?.url + '/' + this.location?.url;
        break;
      }
      case 'adventures': {
        route = '/adventures/' + this.location.url;
        break;
      }
      case 'routes': {
        let countryUrl = findFirstCountryUrl(this.location.points);
        const cont = findFirstContinent(this.location.points);
        let continentUrl = cont?.url ?? ''
        if (countryUrl === undefined) {
          countryUrl = 'country';
        }
        if (continentUrl === undefined) {
          continentUrl = 'continent';
        }
        route = '/destinations/' + continentUrl + '/' + countryUrl + '/route/' + this.location.url;
        break;
      }
    }
    const url = window.location.origin + route;
    window.open(url, '_blank');
  }

  getFirstValidContinentUrl(location: LocationDto) {
    if (!location?.points?.length) {
      return '';
    }
    for (const point of location.points) {
      if (!point?.cities?.length) {
        continue;
      }
      for (const city of point.cities) {
        const url = city?.country?.continent?.url;
        if (url !== undefined) {
          return url;
        }
      }
    }
    return '';
  }

  getFirstCountryUrl(location: LocationDto) {
    return location?.points?.find(point =>
      point?.cities?.find(city => city?.country?.url !== undefined)
    )?.cities?.find(city => city?.country?.url !== undefined)?.country?.url;
  }

  getSelectedCities(index: number) {
    return this.location.points[index].cities ?? [];
  }

  getSelectedAdventures() {
    return this.location.adventures ?? [];
  }

  getUnselectedCities() {
    return this.PointsCityList;
  }

  getUnselectedAdventures() {
    const selectedAdventures = this.getSelectedAdventures();
    return this.hotelAdventuresList.filter(adventure =>
      !selectedAdventures.some(selected => selected.id === adventure.id)
    );
  }

  addCity(index: number, cityJson: string) {
    if (!cityJson) return;

    try {
      const cityToAdd = JSON.parse(cityJson);
      if (!this.location.points[index].cities) {
        this.location.points[index].cities = [];
      }
      if (!this.location.points[index].cities.some(c => c.id === cityToAdd.id)) {
        this.location.points[index].cities.push(cityToAdd);
      }
      const selectElement = document.getElementById('citiesSelect') as HTMLSelectElement;
      if (selectElement) {
        selectElement.value = '';
      }
    } catch (e) {
    }
  }

  addAdventure(adventuresJson: string) {
    if (!adventuresJson) return;

    try {
      const adventureToAdd = JSON.parse(adventuresJson);
      if (!this.location.adventures) {
        this.location.adventures = [];
      }
      if (!this.location.adventures.some(adventure => adventure.id === adventureToAdd.id)) {
        this.location.adventures.push(adventureToAdd);
      }
      const selectElement = document.getElementById('adventuresSelect') as HTMLSelectElement;
      if (selectElement) {
        selectElement.value = '';
      }
    } catch (e) {
    }
  }

  removeCity(pointIndex: number, cityIndex: number) {
    if (this.location.points[pointIndex].cities) {
      this.location.points[pointIndex].cities.splice(cityIndex, 1);
    }
  }

  removeAdventure(adventuresIdx: number) {
    if (this.location.adventures) {
      this.location.adventures.splice(adventuresIdx, 1);
    }
  }

  setActivePointTab(index: number): void {
    this.activePointTab = index;
  }

  updatePointTabTitle(pointIndex: number): void {
    // Заголовок обновится автоматически через биндинг
  }

  back() {
    this.editMode = 'list';
    this.settings = this.adminSettings.getAdminSetting();
    this.params = this.settings.paginationParams;
    this.currentSortHeader = this.settings.currentSortHeader;
    this.currentSort = this.settings.currentSort;
    this.getList();
  }

  logout() {
    this.loginService.logout();
  }

  protected readonly Icons = Icons;
  protected readonly environment = environment;
  protected readonly sortOrder = sortOrder;
  protected readonly IconsClouds = IconsClouds;
  protected readonly IconsCloudsArray = IconsCloudsArray;
  protected readonly findIconByAlt = findIconByAlt;
}
